import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import {
  dictionariesApi,
  growthToolsApi,
  notificationsApi,
  platformReportsApi,
  profileApi,
  projectsApi,
  recommendationsApi,
  socialOrdersApi,
  teamsApi,
  usersApi,
} from '../api'

// import { someApi } from 'api'

export const store = configureStore({
  reducer: {
    // someSlice: someSliceReducer, // обычный slice
    // [someApi.reducerPath]: someApi.reducer,  // из api
    [profileApi.reducerPath]: profileApi.reducer,
    [dictionariesApi.reducerPath]: dictionariesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [teamsApi.reducerPath]: teamsApi.reducer,
    [growthToolsApi.reducerPath]: growthToolsApi.reducer,
    [socialOrdersApi.reducerPath]: socialOrdersApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [platformReportsApi.reducerPath]: platformReportsApi.reducer,
    [recommendationsApi.reducerPath]: recommendationsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // .concat(someApi.middleware)
      .concat(profileApi.middleware)
      .concat(dictionariesApi.middleware)
      .concat(usersApi.middleware)
      .concat(projectsApi.middleware)
      .concat(teamsApi.middleware)
      .concat(growthToolsApi.middleware)
      .concat(socialOrdersApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(platformReportsApi.middleware)
      .concat(recommendationsApi.middleware),
})
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
